export default {
  screeningDates: [],
};
